<template>
  <div
    :id="id"
    class="modal-title-list-view is-multiple-detail"
  >
    <p class="title">{{ data ? 'Edit Tab' : 'Add Tab' }}</p>

    <div class="form-group">
      <input
        v-model="dataSetup.title"
        :class="{'error-input' : $v.dataSetup.title.$error}"
        placeholder="Tab Title"
        type="text"
      >
    </div>

    <div
      :class="data ? 'justify-content-between' : 'justify-content-end'"
      class="d-flex mt-4"
    >
      <button
        v-if="data"
        class="button-border"
        @click="$emit('delete-tab')"
      >
        <i class="fa fa-trash mr-2" /> Delete
      </button>

      <div class="d-flex align-items-center">
        <button
          class="button-border mr-2"
          @click="$emit('close-modal')"
        >
          Close
        </button>
        <button
          :disabled="!dataSetup.title"
          class="button-blue"
          @click="submitForm"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dataSetup: {
        title: null,
      },
    };
  },

  created() {
    if (this.data) this.dataSetup.title = this.data;
  },

  methods: {
    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup.title);
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        title: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalSetupTab.vue